export default __webpack_public_path__ + "static/media/card-image3.4f2e74d7.png";